
export const LikedByUser = (tweetsArray: any, userLikesArray: any) => {
  // console.log("LIKED BY USER---", userLikesArray)
  const tweets = tweetsArray.map((tweet: any) => {
    const tweetPublicKey = tweet.publicKey.toString();
    // console.log("LIKED BY USER--- PUBLIC KEY", tweetPublicKey);
    const isLiked = setUserLikes(tweetPublicKey, userLikesArray);
    return { ...tweet, likedByUser: isLiked }
  })
  return tweets;
}

function setUserLikes(tweetPublicKey: any, userLikesArray: any) {

  if (userLikesArray.includes(tweetPublicKey)) {
    return true;
  } else {
    return false;
  }
}